import BrandTagList from './BrandTagList.Container';

export default BrandTagList;
